import { ReduxService } from 'dashboard-services/services';

import { htmlEditorActions } from 'actions/modules/tools';

export const htmlEditorInitialState = {
  disabled: false,
  open: false,
  fileId: undefined,
  provider: undefined
}

export default (state = htmlEditorInitialState, action) => {

  switch (action.type) {
    case htmlEditorActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}